<template>
  <header id="header" class="dynassurance">
    <div class="top_bar mobile_wpml_hidden mobile_contacts_hidden mobile_socials_hidden mobile_cart_hidden mobile_search_hidden">
      <div class="container">

        <div class="top_bar_info_wr" style="justify-content: right">
          <div class="top_bar_info_switcher">
            <div class="active">
              <i style='font-size:30px' class='fa fa-user-circle'></i>
              <span>
                {{mechanicName}}
              </span>
            </div>
            <ul style="display: none;">
              <li v-if="$can('read', 'account_representative') && !is_MUTUAIDE_commercial">
                <a href="/my-account-representative">
                  Mon compte
                </a>
              </li>
              <li v-else-if="!$can('read', 'account_representative')">
                <a href="/my-account">
                  Mon compte
                </a>
              </li>
              <li v-if="$can('read', 'account_representative') && !is_MUTUAIDE_commercial">
                <a href="/my-documents">
                  Mes documents
                </a>
              </li>
              <li>
                <a href="#" @click="$root.logOut">
                  Déconnexion
                </a>
              </li>
            </ul>
          </div>
          <ul class="top_bar_info" id="top_bar_info_0" style="display: block;">
            <li>

            </li>
            <li>
              <i class="stm-clock6" style="font-size: 15px; color: #fde428;"></i>
              <span>
                            <center>Bienvenue {{mechanicGarage}} - {{mechanicCode}}</center>                     </span>
            </li>
            <li>

            </li>
          </ul>
        </div>
      </div>
      <div class="header-box">
        <div class="container">
          <div class="logo-box" style="margin: 10px 0 10px;" v-if="is_Saga">
            <div class="logo logo-desktop">
              <a href="https://www.sagaenligne.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
                <img src="../../assets/img/saga.png" style="width: 100px;" alt="saga">
              </a>
            </div>
            <div class="logo logo-mobile">
              <a href="https://www.sagaenligne.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
                <img src="../../assets/img/saga.png" style="width: 100px; height: px;" alt="saga">
              </a>
            </div>
            <div class="menu-toggle">
              <button>&nbsp;</button>
            </div>
          </div>
          <div class="logo-box" v-else>
            <div class="logo logo-desktop" v-if="is_Sarrut">
              <a href="https://sarrut-assurances-sp.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
                <img src="../../assets/img/sarrut.jpg" style="width: 300px;" alt="sarrut">
              </a>
            </div>
            <div class="logo logo-desktop" v-else-if="is_LeMondeCampingCar">
              <a href="https://sarrut-assurances-sp.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
                <img src="../../assets/img/lemonde.png" style="width: 300px;" alt="lemonde">
              </a>
            </div>
            <div class="logo logo-desktop" v-else>
              <a href="https://www.dynassurances.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
                <img src="https://www.dynassurances.fr/wp-content/uploads/2019/09/Arriere-plan.png" style="width: 300px;" alt="dynassurances">
              </a>
            </div>
            <div class="logo logo-mobile" v-if="is_Sarrut">
              <a href="https://sarrut-assurances-sp.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
                <img src="../../assets/img/sarrut.jpg" style="width: 300px; height: px;" alt="sarrut">
              </a>
            </div>
            <div class="logo logo-mobile" v-else-if="is_LeMondeCampingCar">
              <a href="https://sarrut-assurances-sp.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
                <img src="../../assets/img/lemonde.png" style="width: 300px;" alt="lemonde">
              </a>
            </div>
            <div class="logo logo-mobile" v-else>
              <a href="https://www.dynassurances.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
                <img src="https://www.dynassurances.fr/wp-content/uploads/2019/09/Arriere-plan.png" style="width: 300px; height: px;" alt="dynassurances">
              </a>
            </div>
            <div class="menu-toggle">
              <button>&nbsp;</button>
            </div>
          </div>
          <div class="logo-mutuaide" v-if="is_MUTUAIDE_representative || is_MUTUAIDE_commercial || $can('be', 'broker')">
            <a href="https://www.mutuaide.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../assets/img/logo_mut.jpg" style="width: 100px;" alt="mutuaide">
            </a>
          </div>
          <div class="logo-truffaut" v-if="$can('be', 'garden')">
            <a href="https://www.truffaut.com/" target="_blank" style="margin: 0px 0px 0px 0px;">
              <img src="../../assets/img/truffaut.jpg" style="width: 200px;" alt="truffaut">
            </a>
          </div>
          <div class="nav-box affix-top" v-if="!$can('be', 'representative') && !$can('be', 'broker') && !$can('be', 'garden') && !is_Sarrut && !is_Saga && !is_LeMondeCampingCar">
            <ul id="menu-menu-principal" class="main_menu_nav">
              <li  class="menu-item-has-children"><a href="https://www.dynassurances.fr/qui-sommes-nous/" target="_blank">Qui sommes-nous</a>
                <ul class="sub-menu">
                  <li ><a href="https://www.dynassurances.fr/qui-sommes-nous#presentation" target="_blank">Présentation</a></li>
                  <li><a href="https://www.dynassurances.fr/qui-sommes-nous/#chiffes" target="_blank">Chiffes clés</a></li>
                  <li><a href="https://www.dynassurances.fr/qui-sommes-nous/#developpement" target="_blank">Notre développement</a></li>
                  <li ><a href="https://www.dynassurances.fr/qui-sommes-nous/#metiers" target="_blank">Nos métiers</a></li>
                </ul>
              </li>
              <li  class="menu-item-has-children"><a href="#">Nos services</a>
                <ul class="sub-menu">
                  <li class="menu-item-has-children"><a href="https://www.dynassurances.fr/risque-des-entreprises/" target="_blank">Risque des entreprises</a>
                    <ul class="sub-menu">
                      <li ><a href="https://www.dynassurances.fr/la-responsabilite-civile/" target="_blank">La Responsabilité civile</a></li>
                      <li><a href="https://www.dynassurances.fr/les-flottes-automobiles/" target="_blank">Les flottes Automobiles</a></li>
                      <li><a href="https://www.dynassurances.fr/assurance-construction/" target="_blank">Assurance Construction</a></li>
                      <li><a href="https://www.dynassurances.fr/assurance-transport-de-marchandises/" target="_blank">Transport de marchandises</a></li>
                      <li><a href="https://www.dynassurances.fr/le-risque-cyber/" target="_blank">Le risque cyber</a></li>
                    </ul>
                  </li>
                  <li class="menu-item-has-children"><a href="https://www.dynassurances.fr/risque-du-particulier/" target="_blank">Risque du particulier</a>
                    <ul class="sub-menu">
                      <li><a href="https://www.dynassurances.fr/assurance-auto/" target="_blank">Assurance Auto</a></li>
                      <li><a href="https://www.dynassurances.fr/assurance-moto/" target="_blank">Assurance Moto</a></li>
                      <li><a href="https://www.dynassurances.fr/assurance-habitation/" target="_blank">Assurance Habitation</a></li>
                      <li><a href="https://www.dynassurances.fr/assurances-sante/" target="_blank">Assurances Santé</a></li>
                      <li><a href="https://www.dynassurances.fr/autres-assurances/" target="_blank">Autres assurances</a></li>
                    </ul>
                  </li>
                  <li><a href="https://assur-garantiesmecaniques.fr/" target="_blank">Les garanties «Pannes Mécaniques»</a></li>
                  <li><a href="https://assur-camping-car.fr/" target="_blank">Le Camping-car</a></li>
                </ul>
              </li>
              <li><a href="https://www.dynassurances.fr/blog/" target="_blank">Actualité</a></li>
              <li><a href="https://www.dynassurances.fr/equipe/" target="_blank">L’équipe</a></li>
              <li><a href="https://www.dynassurances.fr/contact/" target="_blank">Contact</a></li>
            </ul>
        </div>
          <div class="socials-box	hide_on_mobile" v-if="!$can('be', 'representative') && !$can('be', 'broker') && !$can('be', 'garden') && !is_Sarrut && !is_Saga && !is_LeMondeCampingCar">
            <a target="_blank" href="https://twitter.com/dynassurances">
              <i class="fa fa-twitter">&nbsp;</i>
            </a>
            <a target="_blank" href="https://www.facebook.com/Dynassurances/">
              <i class="fa fa-facebook">&nbsp;</i>
            </a>
            <a target="_blank" href="https://www.linkedin.com/company/dynassurances">
              <i class="fa fa-linkedin">&nbsp;</i>
            </a>
          </div>

        </div>
      </div>

    </div>
  </header>
</template>

<script>
    export default {
        name: "Dynassurances",
        props: {
          mechanicName: {
            default: '',
            type: String
          },
          mechanicGarage: {
            default: '',
            type: String
          },
          mechanicCode: {
            default: '',
            type: String
          }
        },
      computed: {
        is_MUTUAIDE_representative() {
          return this.$store.state.userInfo.representative ? (this.$store.state.userInfo.representative.id == 13) : false;
        },
        is_MUTUAIDE_commercial() {
          return this.$store.state.userInfo.representative ? (this.$store.state.userInfo.representative.id == 15) : false;
        },
        is_Sarrut() {
          // return this.$store.state.userInfo.mechanic ? (this.$store.state.userInfo.mechanic.id == 4857) : false;
          if (this.$store.getters.isSarrutAdmin || this.$store.getters.isSarrut)
            return true;
          else
            return false;
        },
        is_Saga() {
          if (this.$store.getters.isSagaAdmin || this.$store.getters.isSaga)
            return true;
          else
            return false;
        },
        is_LeMondeCampingCar() {
          if (this.$store.getters.isLeMondeCampingCar)
            return true;
          else
            return false;
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Headers/Dynassurances.vue